import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Edit } from '@styled-icons/boxicons-solid/Edit';
import ThemeTypography from 'DesignSystem/Primitives/Typography/ThemeTypography';
import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { ImpactClaim } from 'FeatureModules/Request/types/impactClaim.types';

interface IImpactClaimsCollectionProps {
  impactClaims: ImpactClaim[];
  loading?: boolean;
  /** When clicking on the button it will go to the impact claims page, make sure the list is filtered on the correct text, for example the product or partner name */
  searchQuery?: string;
}

const ImpactClaimIcon = styled('div')(({ theme }) => ({
  width: 28,
  height: 28,
  padding: 3,
  border: `1px solid ${theme.custom.themeColors.grayScale[20]}`,
  borderRadius: '50%',
  boxSizing: 'border-box',
  backgroundColor: theme.palette.common.white,

  '& img': {
    width: '100%',
  },

  '&:not(:first-of-type)': {
    marginLeft: -13,
  },

  '&:last-of-type': {
    marginRight: 10,
  },
}));

const StyledButton = styled(Button)(({ theme }) => ({
  overflow: 'hidden',
  border: `1px solid ${theme.custom.themeColors.primary[5]}`,
  borderRadius: 50,
  whiteSpace: 'nowrap',
  display: 'flex',
}));

const EditIcon = styled(Edit)(({ theme }) => ({
  color: theme.custom.themeColors.grayScale[100],
  marginLeft: 30,
}));

const ImpactClaimsCollection: FC<IImpactClaimsCollectionProps> = ({
  impactClaims,
  searchQuery,
}) => {
  const navigate = useNavigate();

  const onClick = () => {
    navigate('/impact-claims/active', {
      state: {
        search: `?query=${searchQuery}`,
      },
    });
  };

  return (
    <StyledButton variant="outlined" onClick={onClick}>
      {impactClaims.slice(0, 2).map(({ impactCatalogItem }) => (
        <ImpactClaimIcon key={impactCatalogItem.id}>
          <img alt={impactCatalogItem.title} src={impactCatalogItem.iconUrl} />
        </ImpactClaimIcon>
      ))}

      <ThemeTypography variant="BUTTON_LARGE">Impact claims</ThemeTypography>

      <EditIcon size={16} />
    </StyledButton>
  );
};

export default ImpactClaimsCollection;
